/**
 * Off-screen field for bots. Hidden from sight, the keyboard and screen readers;
 * people never fill it, form-filling bots usually do. Pair with useAntiSpam().
 */
export default function Honeypot({ id, value, onChange }) {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute -left-[10000px] top-auto h-px w-px overflow-hidden">
      <label htmlFor={id}>Leave this field empty</label>
      <input
        id={id}
        name="website"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        placeholder="Leave empty"
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
